import { useState, useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { Globe, ChevronDown } from 'lucide-react';
import { SUPPORTED_LANGS } from '../i18n/i18n';

const LANG_LABELS = {
  es: 'Español',
  en: 'English',
  ru: 'Русский',
  fr: 'Français',
};

export default function LangSelector() {
  const { t, i18n } = useTranslation();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  const current = (i18n.resolvedLanguage || i18n.language || 'es').toLowerCase();

  useEffect(() => {
    if (!open) return;
    const handle = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener('mousedown', handle);
    document.addEventListener('touchstart', handle);
    return () => {
      document.removeEventListener('mousedown', handle);
      document.removeEventListener('touchstart', handle);
    };
  }, [open]);

  const pick = (code) => {
    i18n.changeLanguage(code);
    setOpen(false);
  };

  return (
    <div className="lang-selector" ref={ref}>
      <button
        type="button"
        className="lang-trigger"
        onClick={() => setOpen((v) => !v)}
        aria-haspopup="listbox"
        aria-expanded={open}
        aria-label={t('comun.cambiar_idioma')}
      >
        <Globe size={14} strokeWidth={1.5} />
        <span className="lang-trigger-code">{current.toUpperCase()}</span>
        <ChevronDown
          size={12}
          strokeWidth={1.75}
          className={'lang-chev' + (open ? ' is-open' : '')}
        />
      </button>

      {open && (
        <ul className="lang-menu" role="listbox">
          {SUPPORTED_LANGS.map((code) => (
            <li key={code} role="option" aria-selected={current === code}>
              <button
                type="button"
                className={'lang-option' + (current === code ? ' active' : '')}
                onClick={() => pick(code)}
              >
                <span className="lang-code">{code.toUpperCase()}</span>
                <span className="lang-name">{LANG_LABELS[code]}</span>
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
